import {
    CreateCouponRequest, CreateCouponResponse, DeleteCouponRequest, DeleteCouponResponse,
    GetCouponsRequest, GetCouponsResponse, UpdateCouponRequest, UpdateCouponResponse
} from "./requestsResponses";
import { CouposApiMethods } from "./methods";
import { execute } from "../../apiCommandsExecutor";
import { ExecutionStatus } from "../general/requestsResponses";


export const getCoupons = async (params: GetCouponsRequest) => {
    const response = await execute<GetCouponsRequest, GetCouponsResponse>(
        CouposApiMethods.getCoupons,
        params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
        coupons: response.data.coupons,
        total: response.data.total,
        activationsByCouponId: response.data.activationsByCouponId
    };
};

export const createCoupon = async (params: CreateCouponRequest) => {
    const response = await execute<CreateCouponRequest, CreateCouponResponse>(
        CouposApiMethods.createCoupon,
        params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
    };
};

export const updateCoupon = async (params: UpdateCouponRequest) => {
    const response = await execute<UpdateCouponRequest, UpdateCouponResponse>(
        CouposApiMethods.updateCoupon,
        params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
    };
};

export const deleteCoupon = async (params: DeleteCouponRequest) => {
    const response = await execute<DeleteCouponRequest, DeleteCouponResponse>(
        CouposApiMethods.deleteCoupon,
        params);
    return {
        err: !(response.status === 200 && response.data.executionStatus === ExecutionStatus.Finished),
    };
};

